import MSlice from "../../helper/MSlice";

const handleLoading = (state) => {
  state.error = null;
  state.loading = true;
};

const handleArchiveRequestSuccess = (state, action) => {
  const { data, filter } = action.payload;

  const mBoard = state.boards?.[filter] || {};
  const list = mBoard?.list?.filter((id) => id !== data?._id);
  state.boards[filter] = Object.assign({}, mBoard, {
    list,
    meta: Object.assign({}, mBoard?.meta, {
      totalCount: mBoard?.meta?.totalCount - 1,
    }),
  });

  state.loading = false;
};
const handleInsightDetailsSuccess = (state, action) => {
  const payload = action.payload;
  const _id = payload._id;

  state.map[_id] = Object.assign({}, state.map[_id], { insight: payload }, {
    loading: false,
    error: null,
  });
};

const handleError = (state, action) => {
  state.error = action.payload;
  state.loading = false;
};

const projectSlice = new MSlice({
  name: "project",
  reducers: {
    onUpdateSectionFieldsRequest: MSlice.handleLoading,
    onShareWithRequest: MSlice.handleLoading,
    reopenRequest: handleLoading,

    getInsightDetailsRequest: MSlice.handleLoading,
    getInsightDetailsSuccess: handleInsightDetailsSuccess,

    archiveRequest: handleLoading,
    onArchiveRequestSuccess: handleArchiveRequestSuccess,
    onArchiveRequestFailure: handleError,
  },
});

export const projectActions = projectSlice.getActions();

export default projectSlice.getReducer();
